export const COLORS = {
    white: "#ffffff",
    black: "#000000",
    gray: {
        300: "#CBCBCB",
        400: "#A8A8A8",
        500: "#6B6B6B",
    },
    orange: "#F5DCC5",
    blue: {
        200: "#749FA5",
        300: "#3B6C8D",
        400: "#597F84",
    },
    transparent: {
        w40: "rgba(255,255,255,0.4)",
        b40: "rgba(0,0,0,0.4)",
        w80: "rgba(255,255,255,0.8)",
        b80: "rgba(0,0,0,0.8)",
        w90: "rgba(255,255,255,0.9)",
    },
    brown: "#F5F3EF",
    mint: "#E5F5F7",
    pink: "#DD107F",
    beige: "#FCF2E8",
    positive: "#608D33",
    negative: "#8d3333",
    none: "",
} as const;
